import iraceLogo from '../assets/irace-logo.png';
import { Spinner } from '../components/Spinner.tsx';
import { COPY } from '../copy/vi.ts';

/**
 * M00 (§5, §28.1) — the one screen that carries the iRace logo.
 *
 * Layout is centred and fixed-height so the transition to the form does not
 * jump; §5 explicitly calls out avoiding layout shift here.
 */
export function BootstrapLoading() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-[480px] flex-col items-center justify-center gap-6 p-8">
      <img src={iraceLogo} alt="iRace" className="w-35" />
      <Spinner label={COPY.loading.title} />
    </div>
  );
}

/** M00 offline variant (§5): no shell cache, no bootstrap, recoverable. */
export function BootstrapOffline({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-[480px] flex-col items-center justify-center gap-6 p-8 text-center">
      <img src={iraceLogo} alt="iRace" className="w-35" />
      <p className="max-w-70 text-base leading-relaxed text-text-muted">
        {COPY.loading.offlineFirstLoad}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="h-13 w-full max-w-70 rounded-control bg-brand px-6 text-base font-extrabold tracking-wide text-brand-contrast"
      >
        {COPY.loading.retry}
      </button>
    </div>
  );
}
